import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = ({ isAdminLoggedIn, onAdminLogin, onAdminLogout }) => {
  const location = useLocation();
  
  // Check if we're on admin pages
  const isAdminPage = location.pathname === '/staff' || location.pathname === '/users' || location.pathname === '/updates';

  return (
    <nav className="bg-gradient-to-r from-blue-700 via-blue-600 to-orange-600 shadow-2xl">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-18">
          <Link to="/" className="flex items-center space-x-3 hover:opacity-90 transition-opacity">
            <div className="relative">
              <div className="w-12 h-12 bg-white bg-opacity-20 rounded-xl flex items-center justify-center backdrop-blur-sm border border-white border-opacity-30">
                <i className="fas fa-store text-white text-2xl"></i>
              </div>
              <div className="absolute -top-1 -right-1 w-4 h-4 bg-orange-400 rounded-full animate-pulse"></div>
            </div>
            <div>
              <h1 className="text-2xl font-bold text-white tracking-wide">
                Ashop
                <span className="text-orange-300 ml-2 font-light">Rotterdam</span>
              </h1>
              <p className="text-white text-opacity-80 text-sm">Your One-Stop Shop</p>
            </div>
          </Link>
          
          {/* Only show buttons if NOT on admin pages */}
          {!isAdminPage && (
            <div className="flex space-x-2">
              <Link
                to="/"
                className={`px-6 py-3 rounded-xl font-semibold transition-all duration-200 ${
                  location.pathname === '/'
                    ? 'bg-white text-blue-600 shadow-xl border-2 border-white'
                    : 'bg-white bg-opacity-20 text-white hover:bg-white hover:bg-opacity-30 backdrop-blur-sm border border-white border-opacity-30'
                }`}
              >
                <i className="fas fa-home mr-2"></i>
                Home
              </Link>

              <Link
                to="/contact"
                className={`px-6 py-3 rounded-xl font-semibold transition-all duration-200 ${
                  location.pathname === '/contact'
                    ? 'bg-white text-orange-600 shadow-xl border-2 border-white'
                    : 'bg-white bg-opacity-20 text-white hover:bg-white hover:bg-opacity-30 backdrop-blur-sm border border-white border-opacity-30'
                }`}
              >
                <i className="fas fa-phone mr-2"></i>
                Contact
              </Link>

              {/* Admin Portal - Only show if logged in */}
              {isAdminLoggedIn ? (
                <>
                  <Link
                    to="/staff"
                    className={`px-6 py-3 rounded-xl font-semibold transition-all duration-200 ${
                      location.pathname === '/staff'
                        ? 'bg-white text-indigo-600 shadow-xl border-2 border-white'
                        : 'bg-white bg-opacity-20 text-white hover:bg-white hover:bg-opacity-30 backdrop-blur-sm border border-white border-opacity-30'
                    }`}
                    data-testid="staff-nav-link"
                  >
                    <i className="fas fa-shield-alt mr-2"></i>
                    Admin Portal
                  </Link>
                  
                  <button
                    onClick={onAdminLogout}
                    className="px-4 py-3 rounded-xl font-semibold bg-red-500 text-white hover:bg-red-600 transition-all duration-200"
                  >
                    <i className="fas fa-sign-out-alt mr-2"></i>
                    Logout
                  </button>
                </>
              ) : (
                <button
                  onClick={onAdminLogin}
                  className="px-6 py-3 rounded-xl font-semibold bg-white bg-opacity-20 text-white hover:bg-white hover:bg-opacity-30 backdrop-blur-sm border border-white border-opacity-30 transition-all duration-200"
                >
                  <i className="fas fa-key mr-2"></i>
                  Login
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;